import { ReachAPI } from '../../../ReachApi';
import { StocksApiStockData, StocksApiCurrencyItemData } from '../../../ReachApi/stocks.interface';
import { Signage } from '../../../Signage';
import {
    ChartDataItemResponse,
    ChartDataResponse,
    CurrencyDataResponse,
    CurrencyHistoricalItemResponse,
    QuoteDataResponse,
    PublicApiStocks,
} from './Interface/Stocks';

export const Stocks: PublicApiStocks = {
    getChartData: async function (
        symbol: string,
        interval?: string,
        range?: string
    ): Promise<ChartDataResponse> {
        const result = await ReachAPI.deferredToPromise(
            ReachAPI.stocks.getStockChartData(symbol, Signage.playerUuid, interval, range)
        );

        return {
            metadata: {
                chartPreviousClose: result.data.metadata.chartPreviousClose,
                regularMarketPrice: result.data.metadata.regularMarketPrice,
            },
            chartData: result.data.chart_data.map(
                ([timestamp, stockValue]: [number, number]): ChartDataItemResponse => {
                    return {
                        timestamp: timestamp,
                        stockValue: stockValue,
                    };
                }
            ),
        };
    },

    getCurrencyData: async function (): Promise<CurrencyDataResponse[]> {
        const result = await ReachAPI.deferredToPromise(
            ReachAPI.stocks.getCurrencyData(Signage.playerUuid)
        );

        return result.data.currency_data.map(
            (data: StocksApiCurrencyItemData): CurrencyDataResponse => {
                return {
                    data: {
                        symbol: data.data.symbol,
                        rate: data.data.rate,
                    },
                    historicalData: data.historical_data.map(
                        (historicalData): CurrencyHistoricalItemResponse => {
                            return {
                                timestamp: historicalData.timestamp,
                                rate: historicalData.rate,
                            };
                        }
                    ),
                };
            }
        );
    },

    getQuoteData: async function (symbols: string[]): Promise<QuoteDataResponse[]> {
        const result = await ReachAPI.deferredToPromise(
            ReachAPI.stocks.getStockQuoteData(symbols.join(','), Signage.playerUuid)
        );

        const stockData: StocksApiStockData[] = Object.values(result.data.stock_data);

        return stockData.map((data): QuoteDataResponse => {
            return {
                change: data.quote.change,
                changePercent: data.quote.changePercent,
                companyName: data.quote.companyName,
                latestPrice: data.quote.latestPrice,
                symbol: data.quote.symbol,
            };
        });
    },
};
